import { NgTemplateOutlet } from "@angular/common";
import { Component, inject, signal, ViewChild } from "@angular/core";
import { MatSidenavModule } from "@angular/material/sidenav";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { filter } from "rxjs";

import { GlobalLoadingFacade } from "state/global-loading.facade";

import { GdprBannerComponent } from "../gdpr-banner/gdpr-banner.component";
import { LogoutIdleDirective } from "../logout-idle/logout-idle.directive";
import { MobileNavComponent } from "../nav-header/components/mobile-nav/mobile-nav.component";
import { NavHeaderComponent } from "../nav-header/nav-header.component";
import { VersionSyncBannerComponent } from "../version-sync-banner/version-sync-banner.component";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
  standalone: true,
  imports: [
    NgTemplateOutlet,
    FlexLayoutModule,
    RouterOutlet,
    MatSidenavModule,
    NavHeaderComponent,
    MobileNavComponent,
    GdprBannerComponent,
    VersionSyncBannerComponent,
    LogoutIdleDirective,
  ],
})
export class LayoutComponent {
  private router = inject(Router);
  private readonly globalLoading = inject(GlobalLoadingFacade);

  protected readonly isLoading = this.globalLoading.isLoading;

  protected sidenavVisible = signal<boolean>(false);

  @ViewChild("bannerNavbar")
  private banner?: VersionSyncBannerComponent;

  public get navBarShown(): boolean {
    return (
      this.router.url.includes("/login") === false &&
      this.router.url.includes("/forgot-password") === false &&
      this.router.url.includes("/shared-report") === false &&
      this.router.url.includes("/not-found") === false &&
      this.router.url.includes("/okta-callback") === false &&
      this.router.url.includes("/okta-fallback") === false &&
      this.router.url.includes("/client-auth") === false &&
      this.router.url.includes("export") === false &&
      this.router.url != "/"
    );
  }

  public get isModifiedVersionBannerPage(): boolean {
    return (
      this.router.url.includes("/shared-report") || this.router.url.includes("/not-found")
    );
  }

  constructor() {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      setTimeout(() => {
        const bannerComponent = this.banner;
        bannerComponent?.checkVersion();
      });
    });
  }

  protected showSideNav(): void {
    this.sidenavVisible.set(true);
  }

  protected hideSideNav(): void {
    this.sidenavVisible.set(false);
  }

  protected toggleSideNav(): void {
    this.sidenavVisible.update((visible) => !visible);
  }
}
